(() => {
    UX.topBanner = {
        init: () => {
            const goDown = $('.top-banner__go-down');
            if (goDown.length) {
                $('body').on('click', '.top-banner__go-down', e => {
                    e.preventDefault();
                    const slideShows = $('.showcase-slideshow');
                    slideShows.css('pointer-events', 'none');
                    $('html, body').animate(
                        {
                            scrollTop: $('.top-banner').height(),
                        },
                        400,
                        () => {
                            slideShows.css('pointer-events', '');
                        }
                    );
                });
            }
        },
    };
})();
